import { createAction, props } from '@ngrx/store';
import {
  GeneralNotificationSettings,
  JobNotificationSetting,
  NotificationSetting,
} from '../../interfaces/settings/notification-setting';

export const loadNotificationSettingsGeneral = createAction(
  '[NotificationSettings/API] Load Notification General Settings'
);

export const loadNotificationSettingsGeneralSuccess = createAction(
  '[NotificationSettings/API] Load Notification Settings General Success',
  props<GeneralNotificationSettings>()
);

export const loadNotificationSettingsGeneralFailure = createAction(
  '[NotificationSettings/API] Load Notification Settings General Failure',
  props<{ error: any }>()
);

export const loadNotificationSettingsJobs = createAction('[NotificationSettings/API] Load Notification Jobs Settings');

export const loadNotificationSettingsJobsSuccess = createAction(
  '[NotificationSettings/API] Load Notification Jobs Settings Success',
  props<{ settings: JobNotificationSetting[] }>()
);

export const loadNotificationSettingsJobsFailure = createAction(
  '[NotificationSettings/API] Load Notification Jobs Settings Failure',
  props<{ error: any }>()
);

export const updateNotificationSettingsGeneral = createAction(
  '[NotificationSettings/API] Update Notification Settings General',
  props<GeneralNotificationSettings>()
);

export const updateNotificationSettingsGeneralSuccess = createAction(
  '[NotificationSettings/API] Update Notification Settings General Success',
  props<GeneralNotificationSettings>()
);

export const updateNotificationSettingsGeneralFailure = createAction(
  '[NotificationSettings/API] Update Notification Settings General Failure',
  props<{ error: any }>()
);

export const updateNotificationSettingsJobs = createAction(
  '[NotificationSettings/API] Update Notification Settings Jobs',
  props<{ settings: NotificationSetting[] }>()
);

export const updateNotificationSettingsJobsSuccess = createAction(
  '[NotificationSettings/API] Update Notification Settings Jobs Success',
  props<{ settings: JobNotificationSetting[] }>()
);

export const updateNotificationSettingsJobsFailure = createAction(
  '[NotificationSettings/API] Update Notification Settings Jobs Failure',
  props<{ error: any }>()
);

export const clearNotificationSettings = createAction('[NotificationSettings/API] Clear NotificationSettings');
